import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import AICallCenter from "./pages/AICallCenter";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import ChatToAgent from "./pages/ChatToAgent";
import UrlToAgent from "./pages/UrlToAgent";
import TemplateToAgent from "./pages/TemplateToAgent";
import AdLanding from "./pages/AdLanding";
import NotFound from "./pages/NotFound";
import ReferralProgram from "./pages/ReferralProgram";
import Blog from "./pages/Blog";
import CaseStudies from "./pages/CaseStudies";
import CaseStudyDetail from "./pages/CaseStudyDetail";
import Industries from "./pages/Industries";
import IndustryDetail from "./pages/IndustryDetail";
import WhatIsAIAnsweringService from "./pages/blog/WhatIsAIAnsweringService";
import AIvsHumanAgentsCost from "./pages/blog/AIvsHumanAgentsCost";
import ReduceCustomerSupportCosts from "./pages/blog/ReduceCustomerSupportCosts";
import TopWaysAIPhoneSupport from "./pages/blog/TopWaysAIPhoneSupport";
import IntegrateAIWhatsApp from "./pages/blog/IntegrateAIWhatsApp";
import AIReceptionistForSmallBusiness from "./pages/blog/AIReceptionistForSmallBusiness";
import AIForRealEstateAgents from "./pages/blog/AIForRealEstateAgents";
import AIForMedicalClinics from "./pages/blog/AIForMedicalClinics";
import AIForRestaurants from "./pages/blog/AIForRestaurants";
import BestAIPhoneAgentSoftware from "./pages/blog/BestAIPhoneAgentSoftware";
import HowToSetUpAICallCenter from "./pages/blog/HowToSetUpAICallCenter";
import AIVoiceAgentVsChatbot from "./pages/blog/AIVoiceAgentVsChatbot";
import FutureOfAICustomerService from "./pages/blog/FutureOfAICustomerService";
import ChatGPTMCPPhoneCalls from "./pages/blog/ChatGPTMCPPhoneCalls";
import AIVoiceCloningPhoneAgent from "./pages/blog/AIVoiceCloningPhoneAgent";
import OpenClawPhoneCalls from "./pages/blog/OpenClawPhoneCalls";
import DynamicBlogPost from "./pages/DynamicBlogPost";
import { LocalizedBlogWrapper } from "./components/LocalizedBlogWrapper";
import { LocalizedCaseStudyWrapper } from "./components/LocalizedCaseStudyWrapper";

const queryClient = new QueryClient();

// SEO: redirect www → apex to consolidate ranking signals (Google was indexing both)
if (typeof window !== "undefined" && window.location.hostname === "www.call24x7.ai") {
  window.location.replace(
    `https://call24x7.ai${window.location.pathname}${window.location.search}${window.location.hash}`
  );
}

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/ai-call-center" element={<AICallCenter />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/chat-to-agent" element={<ChatToAgent />} />
          <Route path="/url-to-agent" element={<UrlToAgent />} />
          <Route path="/template-to-agent" element={<TemplateToAgent />} />
          <Route path="/get-started" element={<AdLanding />} />
          <Route path="/referral" element={<ReferralProgram />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/case-studies/:id" element={<CaseStudyDetail />} />
          {/* Localized case study routes */}
          <Route path="/:lang/case-studies/:id" element={<LocalizedCaseStudyWrapper />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/industries/:id" element={<IndustryDetail />} />
          {/* Localized blog routes */}
          <Route path="/blog/:lang/:slug" element={<LocalizedBlogWrapper />} />
          {/* Legacy English blog routes (kept for backward compatibility) */}
          <Route path="/blog/what-is-ai-answering-service" element={<WhatIsAIAnsweringService />} />
          <Route path="/blog/ai-vs-human-agents-cost-comparison" element={<AIvsHumanAgentsCost />} />
          <Route path="/blog/reduce-customer-support-costs-with-ai" element={<ReduceCustomerSupportCosts />} />
          <Route path="/blog/top-ways-businesses-use-ai-phone-support" element={<TopWaysAIPhoneSupport />} />
          <Route path="/blog/integrate-ai-customer-support-whatsapp" element={<IntegrateAIWhatsApp />} />
          <Route path="/blog/ai-receptionist-for-small-business" element={<AIReceptionistForSmallBusiness />} />
          <Route path="/blog/ai-for-real-estate-agents" element={<AIForRealEstateAgents />} />
          <Route path="/blog/ai-for-medical-clinics" element={<AIForMedicalClinics />} />
          <Route path="/blog/ai-for-restaurants" element={<AIForRestaurants />} />
          <Route path="/blog/best-ai-phone-agent-software" element={<BestAIPhoneAgentSoftware />} />
          <Route path="/blog/how-to-set-up-ai-call-center" element={<HowToSetUpAICallCenter />} />
          <Route path="/blog/ai-voice-agent-vs-chatbot" element={<AIVoiceAgentVsChatbot />} />
          <Route path="/blog/future-of-ai-customer-service" element={<FutureOfAICustomerService />} />
          <Route path="/blog/chatgpt-mcp-phone-calls" element={<ChatGPTMCPPhoneCalls />} />
          <Route path="/blog/ai-voice-cloning-phone-agent" element={<AIVoiceCloningPhoneAgent />} />
          <Route path="/blog/openclaw-phone-calls" element={<OpenClawPhoneCalls />} />
          {/* Dynamic blog posts from database */}
          <Route path="/blog/:slug" element={<DynamicBlogPost />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
